import { render, staticRenderFns } from "./FirstStep.vue?vue&type=template&id=20a6f2af&scoped=true&"
import script from "./FirstStep.vue?vue&type=script&lang=js&"
export * from "./FirstStep.vue?vue&type=script&lang=js&"
import style0 from "./FirstStep.vue?vue&type=style&index=0&id=20a6f2af&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "20a6f2af",
  null
  
)

export default component.exports